module.exports = __webpack_public_path__ + "media/images/bg-circle-8a6f2357.png";